import { __assign } from "tslib";
import * as React from 'react';
import { CategorySelector } from './category-selector.comp';
// tslint:disable-next-line:max-line-length
import { createSelectLegacyDriver } from '../../../primitives/selectors/deprecated-single-select/select.legacy-driver';
import { getLegacyBaseDriverFromWrapper } from '../../../common/base-driver';
import { renderAndMountComponent } from '../../../common';
export var createCategorySelectorDriver = function (wrapper) {
    var base = getLegacyBaseDriverFromWrapper(wrapper, '.category-selector', CategorySelector.name);
    return createSelectLegacyDriver(base.elem);
};
export var renderCategorySelectorAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(CategorySelector, __assign({}, props)));
    return createCategorySelectorDriver(elem);
};
//# sourceMappingURL=category-selector.driver.js.map